<app-coming-soon-view [title]='title' [body]="body"></app-coming-soon-view>